
import '../AnimeList.css'
import { Outlet } from 'react-router-dom';

export default  function Category() {






return (
    <>
    <Outlet/>
    </>
);
}




